import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/app.scss';
import Routes from './routes';
import Loadable from 'react-loadable';
import { Provider as ReduxProvider } from 'react-redux'
import configureStore from './store/configureStore';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { BrowserRouter } from 'react-router-dom';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
// import registerServiceWorker from './registerServiceWorker';

// import { injectGlobal } from 'styled-components'
// injectGlobal`
//     @import url("https://fonts.googleapis.com/css?family=Kanit:300,400,500,600,700,900|Roboto:300,400,500,700,900&amp;subset=thai");
//     .th {
//         font-family: "Kanit", sans-serif;
//     }
// `

const store = configureStore( window.REDUX_STATE || {} );

let Lang = window.localStorage.i18nextLng;

if(Lang === 'en-US') {
    i18n.changeLanguage('en');
} else if(Lang === 'th-TH') {
    i18n.changeLanguage('th');
}

const AppBundle = (
   <ReduxProvider store={store}>
        <I18nextProvider i18n={i18n}>
            <BrowserRouter Lang= {Lang}>
                <Routes />
            </BrowserRouter>
        </I18nextProvider>
   </ReduxProvider>
);


Loadable.preloadReady().then(() => {
    ReactDOM.hydrate(
         AppBundle,
      document.getElementById('root')
    );
});

unregisterServiceWorker();

// registerServiceWorker();
// window.onload = () => {
//     Loadable.preloadReady().then(() => {
//         ReactDOM.hydrate(
//              AppBundle,
//           document.getElementById('root')
//         );
//     });
// };


// WEBPACK FOOTER //
// ./src/index.js